const PAGE_TITLE = "Unsettled Bookings";

export { PAGE_TITLE };
